module.exports = __webpack_public_path__ + "img/step2.cecf65c1.png";